export const toSet = <T>(iterable: Iterable<T>): Set<T> => new Set<T>(iterable)
